import React from 'react';
import PropTypes from 'prop-types';
import Link from 'library/components/link';
import { withRouter } from 'library/util/core-router';
import CssDropdown from 'library/structures/css-dropdown';
import TextHelper from 'library/helpers/text';
import Cache from 'library/util/cache';
import PathwayService from 'apps/pathways/services/pathway';

import ReactDOM from 'react-dom';
import Logout from 'library/helpers/logout';

class UserOrNavigation extends React.Component {
    static contextTypes = {
        user: PropTypes.object,
        setUser: PropTypes.func,
        reloadUser: PropTypes.func
    }

    logout = async () => {
        await Logout(false);
        await this.context.setUser(null);
    }

    render() {
        const { user } = this.context;

        if (user) {
            return (
                <CssDropdown label={<span><span className="hide-on-mobile">{[user.first_name, user.last_name].filter(c=>c).map(capitalize).join(' ')}</span> <i className="icon-cog" /></span>}>
                    <Link to={`/`}><i className="icon-path" /> My Pathway</Link>
                    <Link to={`${__PERSONALURL__}/`}><i className="icon-user-circle" /> Personal</Link>
                    <Link to="/edit"><i className="icon-pencil-squared" /> Edit Pathway</Link>
                    <Link to="/settings"><i className="icon-cog" /> Settings</Link>
                    <span onClick={this.logout}><i className="icon-lock" /> Logout</span>
                </CssDropdown>
            );
        }

        return <Link className="button" to={{pathname: '/signin', search: `?from=${this.props.location.pathname}`}}>Login</Link>
    }
}

export default withRouter(UserOrNavigation);
